/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { NavigateFunction } from 'react-router-dom';
import {
    GET_LOCATIONS_FAILURE,
    GET_LOCATIONS_REQUEST,
    GET_LOCATIONS_SUCCESS,
    ADD_LOCATION_FAILURE,
    ADD_LOCATION_REQUEST,
    ADD_LOCATION_SUCCESS,
    REMOVE_LOCATION_FAILURE,
    REMOVE_LOCATION_REQUEST,
    REMOVE_LOCATION_SUCCESS,
    GET_LOCATION_BY_ID_FAILURE,
    GET_LOCATION_BY_ID_REQUEST,
    GET_LOCATION_BY_ID_SUCCESS,
    ADD_TIME_REQUEST,
    ADD_TIME_SUCCESS,
    ADD_TIME_FAILURE,
    EDIT_TIME_REQUEST,
    EDIT_TIME_SUCCESS,
    EDIT_TIME_FAILURE,
    GET_TIME_ID_REQUEST,
    GET_TIME_ID_SUCCESS,
    GET_TIME_ID_FAILURE,
    CLEAR_PREVIOUS_LOCATION_DATA,
    IMPORT_PROPERTIES_REQUEST,
    IMPORT_PROPERTIES_SUCCESS,
    IMPORT_PROPERTIES_FAILURE,
    GET_LOCATION_DETAIL_BY_ID_FAILURE,
    GET_LOCATION_DETAIL_BY_ID_REQUEST,
    GET_LOCATION_DETAIL_BY_ID_SUCCESS,
    GET_OFFICE_HOURS_LOGS_REQUEST,
    GET_OFFICE_HOURS_LOGS_SUCCESS,
    GET_OFFICE_HOURS_LOGS_FAILURE,
    GET_LOCATION_AMENITIES_FAILURE,
    GET_LOCATION_AMENITIES_SUCCESS,
    GET_LOCATION_AMENITIES_REQUEST,
    CLEAR_LOCATION_AMENITIES,
    CREATE_AMENITIES_FAILURE,
    CREATE_AMENITIES_SUCCESS,
    CREATE_AMENITIES_REQUEST,
    RESET_ERROR_MESSAGE,
} from '../constants/location.constants';
import { AmenitiesObj, IconData, MediaFile, UpdateAmenityObject } from '../../../components/amenities/AddEditAmenities/AddEditAmenities';

export interface FileState {
    file: File | null;
    url?: string;
}

// Import Properties

const importPropertiesRequest = () => {
    return {
        type: IMPORT_PROPERTIES_REQUEST,
    };
};

const importPropertiesSuccess = (Data: AnyIfEmpty<object>) => {
    return {
        type: IMPORT_PROPERTIES_SUCCESS,
        payload: Data,
    };
};

const importPropertiesFailure = (Error: string) => {
    return {
        type: IMPORT_PROPERTIES_FAILURE,
        payload: Error,
    };
};

// Get Locations

const getLocationRequest = () => {
    return {
        type: GET_LOCATIONS_REQUEST,
    };
};

const getLocationSuccess = (locationData: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATIONS_SUCCESS,
        payload: locationData,
    };
};

const getLocationFailure = (locationError: string) => {
    return {
        type: GET_LOCATIONS_FAILURE,
        payload: locationError,
    };
};

// Add location

const addLocationRequest = () => {
    return {
        type: ADD_LOCATION_REQUEST,
    };
};

const addLocationSuccess = (addLocationData: AnyIfEmpty<object>) => {
    return {
        type: ADD_LOCATION_SUCCESS,
        payload: addLocationData,
    };
};

const addLocationFailure = (addLocationError: string) => {
    return {
        type: ADD_LOCATION_FAILURE,
        payload: addLocationError,
    };
};

const addTimeRequest = () => {
    return {
        type: ADD_TIME_REQUEST,
    };
};
const addTimeSuccess = (addTimeData: AnyIfEmpty<object>) => {
    return {
        type: ADD_TIME_SUCCESS,
        payload: addTimeData,
    };
};

const addTimeFailure = (addTimeError: string) => {
    return {
        type: ADD_TIME_FAILURE,
        payload: addTimeError,
    };
};

export const resetErrorMessage = () => {
    return {
        type: RESET_ERROR_MESSAGE,
    };
};

//edit office hours
const editTimeRequest = () => {
    return {
        type: EDIT_TIME_REQUEST,
    };
};
const editTimeSuccess = (addTimeData: AnyIfEmpty<object>) => {
    return {
        type: EDIT_TIME_SUCCESS,
        payload: addTimeData,
    };
};
const editTimeFailure = (addTimeError: string) => {
    return {
        type: EDIT_TIME_FAILURE,
        payload: addTimeError,
    };
};

// Remove location

const removeLocationRequest = () => {
    return {
        type: REMOVE_LOCATION_REQUEST,
    };
};

const removeLocationSuccess = (removeLocationData: AnyIfEmpty<object>) => {
    return {
        type: REMOVE_LOCATION_SUCCESS,
        payload: removeLocationData,
    };
};

const removeLocationFailure = (removeLocationError: string) => {
    return {
        type: REMOVE_LOCATION_FAILURE,
        payload: removeLocationError,
    };
};

// Get location by id

const getLocationByIdRequest = () => {
    return {
        type: GET_LOCATION_BY_ID_REQUEST,
    };
};

const getLocationByIdSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_BY_ID_SUCCESS,
        payload: locationByIdData,
    };
};

const getLocationByIdFailure = (locationByIdError: string) => {
    return {
        type: GET_LOCATION_BY_ID_FAILURE,
        payload: locationByIdError,
    };
};

const getLocationDetailByIdRequest = () => {
    return {
        type: GET_LOCATION_DETAIL_BY_ID_REQUEST,
    };
};

const getLocationDetailByIdSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_DETAIL_BY_ID_SUCCESS,
        payload: locationByIdData,
    };
};

const getLocationDetailByIdFailure = (locationByIdError: string) => {
    return {
        type: GET_LOCATION_DETAIL_BY_ID_FAILURE,
        payload: locationByIdError,
    };
};

//get office hours

const getTimeIdRequest = () => {
    return {
        type: GET_TIME_ID_REQUEST,
    };
};

const getTimeIdSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_TIME_ID_SUCCESS,
        payload: locationByIdData,
    };
};

const getTimeIdFailure = (locationByIdError: string) => {
    return {
        type: GET_TIME_ID_FAILURE,
        payload: locationByIdError,
    };
};

const getOfficeHoursLogsRequest = () => {
    return {
        type: GET_OFFICE_HOURS_LOGS_REQUEST,
    };
};

const getOfficeHoursLogsSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_OFFICE_HOURS_LOGS_SUCCESS,
        payload: locationByIdData,
    };
};

const getOfficeHoursLogsFailure = (locationByIdError: string) => {
    return {
        type: GET_OFFICE_HOURS_LOGS_FAILURE,
        payload: locationByIdError,
    };
};

export const getLocation = (navigate?: NavigateFunction, path?: string, useInternalApi?: boolean) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getLocationRequest());
        return await axios
            .get('/admin/locations', {
                headers: {
                    ...(useInternalApi ? { 'x-internal-api': 'true' } : {}), // Append conditionally
                },
            })
            .then(async (response) => {
                typeof path !== 'string' && (await dispatch(getLocationSuccess(response.data)));
                typeof path === 'string' ? navigate?.(path) : navigate?.(-1);
            })
            .catch((err) => dispatch(getLocationFailure(err.message)));
    };
};

export const importProperties = (
    file: AnyIfEmpty<File | object>,
    setToast: (message: string, success: boolean) => void,
    setExcelFile: Dispatch<SetStateAction<FileState>>,
    setModalStep: Dispatch<SetStateAction<number>>,
    setIsLoading: Dispatch<SetStateAction<boolean>>,
) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(importPropertiesRequest());
        return await axios
            .post('/admin/locations/insert-bulk-location', { excelFile: file }, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(async (response) => {
                await dispatch(importPropertiesSuccess(response.data));
                setToast(response.data.message, response.data.statusCode == 201 ? true : false);
                if (response?.data?.statusCode === 201) {
                    setExcelFile({ file: null });
                    setModalStep(1);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                dispatch(importPropertiesFailure(err.message));
            });
    };
};

export const getSearchLocation = (searchUnits: string, locationAvailable?: string) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getLocationRequest());
        return await axios
            .get(
                `/admin/locations/?searchText=${encodeURIComponent(searchUnits)}${
                    locationAvailable !== undefined ? `&locationAvailable=${locationAvailable}` : ''
                }`,
            )
            .then((response) => dispatch(getLocationSuccess(response.data)))
            .catch((err) => dispatch(getLocationFailure(err.message)));
    };
};

export const getFilteredLocation = (searchUnits: string, locationAvailable?: string, xInternalAPI?: boolean) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getLocationRequest());
        return await axios
            .get(`/admin/locations/?searchText=${searchUnits}&locationAvailable=${locationAvailable?.toLowerCase()}`, {
                headers: {
                    ...(xInternalAPI ? { 'x-internal-api': 'true' } : {}),
                },
            })
            .then((response) => dispatch(getLocationSuccess(response.data)))
            .catch((err) => dispatch(getLocationFailure(err.message)));
    };
};

export const addTime = (propertyOH: AnyIfEmpty<object>, setLoading: Dispatch<SetStateAction<boolean>>) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(addTimeRequest());
        return await axios
            .post('/Property-office-hour', propertyOH)
            .then(async (response) => {
                setLoading(true);
                await dispatch(addTimeSuccess(response.data));
            })
            .catch((err) => dispatch(addTimeFailure(err.message)));
    };
};

export const addLocation = (
    addLocationObj: AnyIfEmpty<object>,
    propertyOfficeHours: AnyIfEmpty<object>,
    setLoading: Dispatch<SetStateAction<boolean>>,
    navigate: AnyIfEmpty<object>,
) => {
    if (!addLocationObj.leasingAgentNumber) {
        addLocationObj['leasingAgentNumber'] = null;
    }
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(addLocationRequest());
        return await axios
            .post('/admin/locations', addLocationObj)
            .then(async (response) => {
                if (response?.data?.statusCode === 201) {
                    setLoading(true);
                    await dispatch(addLocationSuccess(response.data));
                    const propertyOH = { location: response.data.data.id, propertyOfficeHours };
                    await dispatch(addTime(propertyOH, setLoading));
                    await dispatch(clearPreviousLocationData());
                    setLoading(false);
                    await dispatch(getLocation(navigate));
                    // window.history.back();
                    navigate && navigate('/locations');
                } else {
                    dispatch(addLocationFailure(response?.data?.message));
                    setLoading(false);
                }
            })
            .catch((err) => {
                dispatch(addLocationFailure(err.message));
            });
    };
};

export const editTime = (id: any, propertyOH: AnyIfEmpty<object>) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(editTimeRequest());
        return await axios
            .patch(`/property-office-hour/${id}`, propertyOH)
            .then(async (response) => {
                await dispatch(editTimeSuccess(response.data));
            })
            .catch((err) => dispatch(editTimeFailure(err.message)));
    };
};

export const editLocation = (
    id: string,
    addLocationObj: AnyIfEmpty<object>,
    propertyOfficeHours: AnyIfEmpty<object> | null,
    setLoading: Dispatch<SetStateAction<boolean>>,
    navigate?: AnyIfEmpty<object>,
) => {
    if (!addLocationObj.leasingAgentNumber) {
        addLocationObj['leasingAgentNumber'] = null;
    }

    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(addLocationRequest());
        return await axios
            .put(`/admin/locations/${id}`, addLocationObj)
            .then(async (response) => {
                if (response?.data?.statusCode !== 200) {
                    dispatch(addLocationFailure(response?.data?.message));
                    setLoading(false);
                    return;
                }
                setLoading(true);
                await dispatch(addLocationSuccess(response.data));
                if (propertyOfficeHours !== null) {
                    await dispatch(editTime(id, { propertyOfficeHours }));
                }
                await dispatch(clearPreviousLocationData());
                await dispatch(getLocation(navigate));
                // window.history.back();
                // navigate && navigate('/locations');
                setLoading(false);
            })
            .catch((err) => {
                dispatch(addLocationFailure(err.message));
                setLoading(false);
            });
    };
};

export const removeLocation = (locationId: string, navigate?: AnyIfEmpty<object>) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(removeLocationRequest());
        return await axios
            .delete(`/admin/locations/${locationId}`)
            .then((response) => {
                dispatch(removeLocationSuccess(response.data));
                navigate('/locations');
                dispatch(getLocation(navigate));
            })
            .catch((error) => dispatch(removeLocationFailure(error.message)));
    };
};

export const getLocationById = (locationId: string | undefined, useInternalApi?: boolean) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getLocationByIdRequest());
        return await axios
            .get(`/admin/locations/${locationId}`, {
                headers: {
                    ...(useInternalApi ? { 'x-internal-api': 'true' } : {}), // Append conditionally
                },
            })
            .then((response) => {
                dispatch(getLocationByIdSuccess(response.data));
            })
            .catch((err) => dispatch(getLocationByIdFailure(err.message)));
    };
};

export const getLocationDetailById = (id: string) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getLocationDetailByIdRequest());
        return await axios
            .get(`/admin/locations/detail/${id}`)
            .then((response) => {
                dispatch(getLocationDetailByIdSuccess({ ...response.data.location, ...response.data.mapFileDetails }));
            })
            .catch((err) => dispatch(getLocationDetailByIdFailure(err.message)));
    };
};

export const getTime = (locationId: string | undefined) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getTimeIdRequest());
        return await axios
            .get(`/Property-office-hour/${locationId}`)
            .then((response) => {
                dispatch(getTimeIdSuccess(response.data));
            })
            .catch((err) => dispatch(getTimeIdFailure(err.message)));
    };
};

const clearPrevLocation = () => {
    return {
        type: CLEAR_PREVIOUS_LOCATION_DATA,
    };
};

export const clearPreviousLocationData = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch(clearPrevLocation());
    };
};

export const getOfficeHourLogs = (locationId: string, activeTab: number) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getOfficeHoursLogsRequest());
        return await axios
            .get(`/audit-logs/Get-logs`, {
                params: {
                    table_name: activeTab === 3 ? 'PropertyOfficeHour' : 'Locations',
                    location_id: locationId,
                },
            })
            .then((response) => {
                dispatch(getOfficeHoursLogsSuccess(response.data));
            })
            .catch((err) => dispatch(getOfficeHoursLogsFailure(err.message)));
    };
};

const getLocationAmenitiesRequest = () => {
    return {
        type: GET_LOCATION_AMENITIES_REQUEST,
    };
};

const getLocationAmenitiesSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: GET_LOCATION_AMENITIES_SUCCESS,
        payload: locationByIdData,
    };
};

const getLocationAmenitiesFailure = (locationByIdError: string) => {
    return {
        type: GET_LOCATION_AMENITIES_FAILURE,
        payload: locationByIdError,
    };
};

export const clearLocationAmenities = () => {
    return {
        type: CLEAR_LOCATION_AMENITIES,
    };
};

export const getLocationAmenities = (locationId: string) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getLocationAmenitiesRequest());
        return await axios
            .get(`/amenities/${locationId}`)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch(getLocationAmenitiesSuccess(response.data));
                }
            })
            .catch((err) => dispatch(getLocationAmenitiesFailure(err.message)));
    };
};

const createAmenitiesRequest = () => {
    return {
        type: CREATE_AMENITIES_REQUEST,
    };
};

const cretaeAmenitiesSuccess = (locationByIdData: AnyIfEmpty<object>) => {
    return {
        type: CREATE_AMENITIES_SUCCESS,
        payload: locationByIdData,
    };
};

const cretaeAmenitiesFailure = (locationByIdError: string) => {
    return {
        type: CREATE_AMENITIES_FAILURE,
        payload: locationByIdError,
    };
};

export const createAmenities = (
    amenitiesObj: AmenitiesObj,
    onCreateAmenitiesSuccess: (successMessage: string) => void,
    onCreateAmenitiesFailure: (errorMessage: string) => void,
) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        const formData = new FormData();
        formData.append(`name`, amenitiesObj.name || '');
        formData.append(`latitude`, String(amenitiesObj.latitude || ''));
        formData.append(`longitude`, String(amenitiesObj.longitude || ''));
        formData.append(`description`, amenitiesObj.description || '');
        formData.append(`amenityWebLink`, amenitiesObj.amenityWebLink || '');
        formData.append(`amenityWebLinkTitle`, amenitiesObj.amenityWebLinkTitle || '');
        formData.append('location', amenitiesObj.location || '');

        amenitiesObj?.mediaFiles?.forEach((file: MediaFile | File) => {
            if (file instanceof File) formData.append(`mediaFiles`, file);
            else formData.append('mediaFiles', file.url);
        });

        dispatch(createAmenitiesRequest());
        return axios
            .post(`/amenities/create-amenities`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => {
                dispatch(cretaeAmenitiesSuccess(response.data));
                if (response?.data?.statusCode === 201) {
                    onCreateAmenitiesSuccess(response?.data?.message);
                } else {
                    onCreateAmenitiesFailure(response?.data?.message);
                }
            })
            .catch((error) => {
                dispatch(cretaeAmenitiesFailure(error));
                onCreateAmenitiesFailure(error);
            });
    };
};

export const deleteAmenity = (amenityId: string, onSuccess: (message: string) => void, onFailure: (errMessage: string) => void) => {
    axios
        .delete(`/amenities/${amenityId}`)
        .then((response) => {
            if (response.data.statusCode === 200) {
                onSuccess(response?.data?.message);
            } else {
                onFailure(response?.data?.message);
            }
        })
        .catch((error) => onFailure(error?.response?.data?.message || 'something went wrong'));
};

export const updateAmenity = (
    amenityId: string,
    updatedObject: UpdateAmenityObject,
    onSuccess: (message: string) => void,
    onFailure: (errMessage: string) => void,
) => {
    const formData = new FormData();
    formData.append(`name`, updatedObject.name || '');
    formData.append(`latitude`, String(updatedObject.latitude || ''));
    formData.append(`longitude`, String(updatedObject.longitude || ''));
    formData.append(`description`, updatedObject.description || '');
    formData.append(`amenityWebLink`, updatedObject.amenityWebLink || '');
    formData.append(`amenityWebLinkTitle`, updatedObject.amenityWebLinkTitle || '');
    formData.append('location', updatedObject.location || '');
    formData.append(`existMediaFiles`, JSON.stringify(updatedObject?.existMediaFiles));

    formData.append(`deletedMediaFiles`, JSON.stringify(updatedObject?.deletedMediaFiles?.map((file: MediaFile) => file.url) || []));

    updatedObject?.newMediaFiles?.forEach((file) => {
        if (file instanceof File) {
            formData.append(`newMediaFiles`, file);
        } else {
            formData.append('newMediaFiles', file.url);
        }
    });

    axios
        .patch(`/amenities/${amenityId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((response) => {
            if (response.data.statusCode === 200) {
                onSuccess(response?.data?.message);
            } else {
                onFailure(response?.data?.message);
            }
        })
        .catch((error) => onFailure(error.response?.data?.message));
};
